import React, { Component } from "react";
import "./index.scss";
import Banner from "../../components/Banner";
import Video from "../../components/Video";
import List from "../../components/List";
import Footer from "../../components/Footer";

class Home extends Component {
  render() {
    // console.log("xx", this.props);

    return (
      <div className="Home">
        <Banner onHeight={this.props.onHeight} />
        <Video videoObj={this.props.videoObj} />
        <List
          onPortal={this.props.onPortal}
          onTemp={this.props.onTemp}
          onWheel={this.props.onWheel}
        />
        <Footer />
      </div>
    );
  }
}

export default Home;
